import formsBackendClient, { type ApiDefinition } from '@/tsClient/servers/noodleQuestionnaires';

import buildPath from '../utilities/buildPath';

type ThisApi = ApiDefinition['/questionnaires/{questionnaireId}/responses/{listFieldTemplateKey}/deleted']['GET'];
type Input = ThisApi['params'];

const getDeletedQuestionnaireResponses = async ({
  questionnaireId,
  listFieldTemplateKey,
}: Input): Promise<ThisApi['response']> => {
  const path = buildPath<ThisApi>('/questionnaires/{questionnaireId}/responses/{listFieldTemplateKey}/deleted', {
    listFieldTemplateKey,
    questionnaireId,
  });
  const data = await formsBackendClient.get(path);
  return data.data;
};

export default getDeletedQuestionnaireResponses;
